import Model from '@/models/Model.js';

export default class UserSetting extends Model {
    static entity = 'user_settings';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            key: this.attr(null),
            value: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
        };
    }

    /**
     * @param key
     * @returns {Item<InstanceOf<UserSetting>>}
     */
    static findByKey(key) {
        const setting = UserSetting.query().where('key', key).first();

        return setting || new UserSetting({ key });
    }

    /**
     * @param value
     * @returns {Promise<*>}
     */
    async set(value) {
        return UserSetting.api().post('/api/user-settings', { key: this.key, value });
    }

    /**
     * @returns {Promise<void>}
     */
    async toggle() {
        return this.set(!this.value);
    }
}
